var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"dashboard-container"},[_c('v-row',{staticClass:"tile-grid"},_vm._l((_vm.tiles),function(tile,i){return _c('v-col',{key:i,staticClass:"tile-column",attrs:{"cols":"12","sm":"6","md":"6","lg":"4","xl":"3"}},[_c('DashboardInfoTile',{attrs:{"tile_data":tile,"loading":tile.loading}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }